<template>
	<div class="desktop-header-container">
      <div
      class="logo-container"
      @click="reloadPage" title="Reload page"
      v-bind:class="{isDarkMode: isDarkMode}">
        <h1 class="title">
          VT Outages
        </h1>
        <h2 class="title sub-title">
          Vermont's Power Outage Resource
        </h2>
        <p class="info"> This is self-reported data from utilities. For the most updated information for your location, please check with your utility.</p>
      </div>
	</div>
</template>

<script>
import AppConfig from "../../resources/AppConfig.js";

const pixelsKey = 'px';
const RESIZE_EVENT_NAME = 'resize';
const setHeaderWidthDelay = 500;
const logoContainerSelector = '.desktop-header-container .logo-container';

export default {
  name: "DesktopHeader",
  props: {
    isDarkMode: Boolean,
    drawerOpen: Boolean,
  },
  data() {
    return {
      drawerWidth: 0
    }
  },
  beforeDestroy() {
    if (this.repeatedTask && typeof this.repeatedTask.cancel === 'function') {
      this.repeatedTask.cancel();
    }
    window.removeEventListener(RESIZE_EVENT_NAME, this.setHeaderWidth);
  },
  created() {
    this.getDrawerWidth();
    setTimeout(() => this.setHeaderHeight(), setHeaderWidthDelay);
    setTimeout(() => this.setHeaderWidth(this.drawerOpen), setHeaderWidthDelay);
    window.addEventListener(RESIZE_EVENT_NAME, this.setHeaderWidth);
  },
  watch: {
    drawerOpen: function () {
      setTimeout(() => this.setHeaderWidth(), setHeaderWidthDelay);
    }
  },
  methods: {
    reloadPage() {
      window.location.reload();
    },
    stringToNumber(stringAsNumber) {
        return parseInt(stringAsNumber, 10);
    },
    setHeaderHeight () {
      const $logoContainer = document.querySelector(logoContainerSelector);
      const $drawerHeader = document.querySelector('#navigation-drawer .header-container');
      if (!$logoContainer || !$drawerHeader) {
        return;
      }
      const $drawerHeaderHeight = window.getComputedStyle($drawerHeader, null).getPropertyValue('height');
      const heightAsNumber = this.stringToNumber($drawerHeaderHeight.replace(pixelsKey, ''));
      if (!Number.isNaN(heightAsNumber)) {
        $logoContainer.style.height =  (heightAsNumber + 1) + pixelsKey;
      }
    },
    setHeaderWidth () {
      const drawerWidth = this.drawerOpen ? this.drawerWidth : 0;
      const windowInnerWidth = window.innerWidth;
      const $logoContainer = document.querySelector(logoContainerSelector);
      if (!$logoContainer) {
        return;
      }
      $logoContainer.style.width = (windowInnerWidth - drawerWidth) + pixelsKey;
    },
    getDrawerWidth() {
      switch(AppConfig.simpleDrawerWidth) {
        case 'small':
          this.drawerWidth = 425;
        break;
        case 'medium':
          this.drawerWidth = 530;
        break;
        case 'large':
          this.drawerWidth = 665;
        break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/partials/_variables.scss";

.desktop-header-container{
  .logo-container{
    position: fixed;
    top: 0;
    left: 0;
    padding: 25px 0 0 25px;
    z-index: 999;
    border: none;
    background-color: $whiteTextTrans85;

    .title{
      margin: 0 0 3px 0;
      font-weight: 1000;
      font-size: 40px;
      text-transform: uppercase;
      color: $navyBackgroundTrans85;
    }

    .sub-title{
      font-size: 15px;
    }

    .info{
      font-size: 14px;
      color: $navyBackgroundTrans85;
    }

    &.isDarkMode{
      background-color: $navyBackgroundTrans85;
      border-bottom: 1px solid $greyTextTrans25;

        .title{
          color: $whiteTextTrans85;
        }
        .sub-title{
          color: $whiteTextTrans85;
        }

        .info{
          color: $whiteTextTrans85;
        }
    }

    &:hover{
        cursor: pointer;
    }
  }
}
</style>
